<template>
    <div :class="[styleType=='img'?'myupleft':'']" v-loading="isLoading">
        <Upload
                ref="upload"
                :show-upload-list="false"
                :default-file-list="defaultList"
                :on-success="handleSuccess"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                :before-upload="handleBeforeUpload"
                :multiple="fileMultiue"
                type="drag"
                :accept="accept"
                action="https://12345678"
                style="display: inline-block;">
            <div class="myu_upload" style="width: 175px;height:154px;" v-if="styleType=='img'">
                <img style="width:30px;height:27px;" src="../../assets/addcontent.png" alt='版权登记'/>
                <p>{{textContent}}</p>
            </div>
            <div :class="styleTypeBg == 'bg'?'bgHover':'btn_upload'"
                 v-if="styleType == 'btn'">
                <p> +上传 </p>
            </div>


        </Upload>
    </div>
</template>
<script>
    import {getHuaWeiToken} from '@/api/staticPage';
    // import OBS from 'huawei-obs';
    // const documnetType = 20971520;
    // const pictureType = 104857600;
    // const videoAndMusic = 524288000;
    // const otherType = 209715200;
    const HWC_KEY = "https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar"
    const type = ['bat', 'exe', 'com', 'DLL', 'MSI', 'VBS', 'VBE', 'JS', 'JSE', 'WSH', 'WSF', 'PBD', 'PB', 'dmg', 'fcd', 'gdb', 'REG', 'SAV', 'str', 'SYS', 'swf', 'VBP', 'VBW', 'VBX', 'VIR', 'VXD', 'WCM', 'WIZ', 'A', 'ADF'];
    const reImg = /^(bmp|png|jpg|gif|jpeg|JPG)$/;
    const reMusic = /^(cd|ogg|mp3|asf|wma|wav|mp3pro|real|ape|module|midi|vqf)$/;
    const reText = /^(doc|docx|dotx|dot|rtf|txt|htm|html|pdf|odt|docm|dotm|xml|mht|csv|xls|xlsx|xltx|xlt|pptx|ppt|potx|pot|pps|ppsx|odp|rp|eddx|mmap|vsd|vsdx|wps|dps|et|numbers|key|pages)$/;
    const reVideo = /^(avi|rmvb|rm|asf|divx|mpg|mpeg|mpe|wmv|mp4|mkv|vob|3gp|dat|mov|mpa|wvx|asx|ts|flv)$/;
    String.prototype.suffix = function () {
        var index1 = this.lastIndexOf(".");
        var index2 = this.length;
        return this.substring(index1 + 1, index2)
    }
    var globalContext = {};
    globalContext.maxTaskNum = 5;
    globalContext.currentTaskNum = 0;

    const _doUpload = (obsClient, uploadPartStatus, _this) => new Promise((res, rej) => {
        var events = require('events');
        var allDoneEe = new events.EventEmitter();
        doUploadPart(obsClient, uploadPartStatus, allDoneEe, _this);
        allDoneEe.on('upload part finished', (result, _parts) => {
            res(result, _parts);
        });

        allDoneEe.on('error', (err) => {
            rej(err);
        });
    });

    // 文件类型签名（魔数）
    const signatures = {
      jpg: ['FF D8 FF DB', 'FF D8 FF E0', 'FF D8 FF E1', 'FF D8 FF E8'],
      jpeg: ['FF D8 FF DB', 'FF D8 FF E0', 'FF D8 FF E1', 'FF D8 FF E8'],
      png: ['89 50 4E 47 0D 0A 1A 0A']
    };
    const checkFileType = (file) => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const buffer = e.target.result;
          const uint8Array = new Uint8Array(buffer);
          const header = Array.from(uint8Array.slice(0, 8))
              .map(b => b.toString(16).toUpperCase().padStart(2, '0'))
              .join(' ');

          // 检查JPEG
          for (const sig of signatures.jpeg) {
            if (header.startsWith(sig)) {
              resolve(true);
              return;
            }
          }

          // 检查PNG
          for (const sig of signatures.png) {
            if (header.startsWith(sig)) {
              resolve(true);
              return;
            }
          }
          // 未知类型
          resolve(false);
        };
        reader.readAsArrayBuffer(file.slice(0, 8)); // 只读取前8个字节
      });
    };

    var doUploadPart = (obsClient, uploadPartStatus, allDoneEe, _this) => {
        while (uploadPartStatus.currentPartIndex < uploadPartStatus.partCount) {
            var offset = uploadPartStatus.currentPartIndex * uploadPartStatus.partSize;
            var currPartSize = (uploadPartStatus.currentPartIndex + 1 === uploadPartStatus.partCount) ? uploadPartStatus.fileSize - offset : uploadPartStatus.partSize;
            var partNumber = uploadPartStatus.currentPartIndex + 1;
            uploadPartStatus.currentPartIndex++;
            globalContext.currentTaskNum++;
            var getCallback = function (partNumber) {
                return function (result) {
                    globalContext.currentTaskNum--;
                    doUploadPart(obsClient, uploadPartStatus, allDoneEe, _this);
                    if (result.CommonMsg.Status < 300) {
                        console.log('Part:' + partNumber + ' finished, etag:' + result.InterfaceResult.ETag);

                        uploadPartStatus.parts.push({PartNumber: partNumber, ETag: result.InterfaceResult.ETag});

                        let uploadProgress = Math.round((uploadPartStatus.parts.length / uploadPartStatus.partCount).toFixed(2) * 100);
                        uploadProgress == 100 ? uploadProgress = 99 : uploadProgress;
                        let uploadListNow = _this.uploadList;
                        for (let i = 0; i < uploadListNow.length; i++) {

                            if (uploadListNow[i].uid == uploadPartStatus.file.uid) {
                                uploadListNow[i].uploadProgress = uploadProgress;
                                break;
                            }
                        }
                        _this.uploadList = uploadListNow
                        _this.$emit("listentochildevent", _this.uploadList)


                        if (uploadPartStatus.parts.length === uploadPartStatus.partCount) {
                            var _parts = uploadPartStatus.parts.sort(function (a, b) {
                                if (a.PartNumber >= b.PartNumber) {
                                    return 1;
                                }
                                return -1;
                            });
                            obsClient.completeMultipartUpload({
                                Bucket: uploadPartStatus.bucketName,
                                Key: uploadPartStatus.objectKey,
                                UploadId: uploadPartStatus.uploadId,
                                Parts: _parts
                            }, function (err, result) {
                                if (!err && result.CommonMsg.Status < 300) {
                                    console.log('Complete to upload multiparts finished.\n');
                                    allDoneEe.emit('upload part finished', result, _parts);
                                } else {
                                    var msg = err || result.CommonMsg.Code;
                                    console.error(msg);
                                    allDoneEe.emit('error', msg);
                                }
                            });
                        }
                    } else {
                        console.error(result.CommonMsg.Code);
                        allDoneEe.emit('error', result.CommonMsg.Code);
                    }
                }
            };

            obsClient.uploadPart({
                Bucket: uploadPartStatus.bucketName,
                Key: uploadPartStatus.objectKey,
                PartNumber: partNumber,
                UploadId: uploadPartStatus.uploadId,
                SourceFile: uploadPartStatus.file,
                Offset: offset,
                PartSize: currPartSize
            }).then(getCallback(partNumber)).catch(function (err) {
                console.error('err:' + err);
                allDoneEe.emit('error', err);
            });
        }
    };
    export default {
        name: 'my-upload-hw',
        props: {
            accept: {
                type: String,
                default: '*'
            },
            textContent: {
                type: String,
                default: '点击或拖拽上传文件'
            },
            fileMultiue: {
                type: Boolean,
                default: true
            },
            oldShowList: {
                type: Array,
                default: () => []
            },
            checkFormat: {
              type: String,
              default: ""
            },
            styleType: {
                type: String,
                default: "img" //上传的样式，是图片，还是按钮
            },
            styleTypeBg: {
                type: String,
                default: "" //上传的样式，是图片，还是按钮
            },
            maxNumber: {
                type: Number,
                default: 10
            },
            documnetTypes: {
                type: Number,
                defalut: 20971520
            },
            pictureTypes: {
                type: Number,
                defalut: 104857600
            },
            videoAndMusics: {
                type: Number,
                defalut: 524288000
            },
            otherTypes: {
                type: Number,
                defalut: 209715200
            },
            maxSizes: {
                type: Number,
                defalut: 1024000 //文件大小限制，单位 kb
            },
        },
        data() {
            return {
                defaultList: [
                    {
                        'name': 'a42bdcc1178e62b4694c830f028db5c0',
                        'url': 'https://o5wwk8baw.qnssl.com/a42bdcc1178e62b4694c830f028db5c0/avatar'
                    },
                    {
                        'name': 'bc7521e033abdd1e92222d733590f104',
                        'url': 'https://o5wwk8baw.qnssl.com/bc7521e033abdd1e92222d733590f104/avatar'
                    }
                ],
                imgName: '',
                visible: false,
                uploadList: [],
                accessKeyId: '',
                accessKeySecret: '',
                stsToken: '',
                md5Hash: '',
                isLoading: false,
                documnetType: 26214400,
                pictureType: 26214400,
                videoAndMusic: 524288000,
                otherType: 26214400,
                maxSize: 1024000,
            }
        },
        mounted() {
            console.log("获取到的图片类限制 ：： ", this.pictureType / 1024 / 1024);
            this.documnetType = this.documnetTypes ? this.documnetTypes : 20971520;
            this.pictureType = this.pictureTypes ? this.pictureTypes : 104857600;
            this.videoAndMusic = this.videoAndMusics ? this.videoAndMusics : 524288000;
            this.otherType = this.otherTypes ? this.otherTypes : 209715200;
            this.maxSize = this.maxSizes ? this.maxSizes : 1024000;
            console.log("图片类的限制：：", this.pictureType);
        },
        methods: {
            handleView(name) {
                this.imgName = name;
                this.visible = true;
            },
            handleRemove(file) {
                const fileList = this.$refs.upload.fileList;
                this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
            },
            handleSuccess(res, file) {
                file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
                file.name = '7eb99afb9d5f317c912f08b5212fd69a';
            },
            handleFormatError(file) {
                this.$Notice.warning({
                    title: 'The file format is incorrect',
                    desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
                });
            },
            handleMaxSize(file) {
                this.$Notice.warning({
                    // title: '超出单个存证对文件最大限制',
                    // desc: '超出单个存证对文件最大限制, 所有类型累计不能超过820M.'
                    title: '提醒',
                    desc: '超出单个上传文件的最大限制'
                });
            },

            handleBeforeUpload: async function (file) {
                await this._getHuaWeiToken();
                console.log('111111111111111111', this.oldShowList)
                var tempdocument = 0;
                var temppicture = 0;
                var tempmv = 0;
                var tempother = 0;
                let _this = this
                if (this.uploadList.length == 0 && this.oldShowList.length != 0) {
                    this.uploadList = this.oldShowList
                }

                if(this.checkFormat == "check"){
                  const isValid = await checkFileType(file);
                  if(!isValid){
                    toast("不支持的文件格式，原格式和后缀名不一致")
                    return false
                  }
                }

                console.log("获取到的file文件", file, this.uploadList)
                if (file.name.indexOf(',') != -1) {
                    toast("文件名称中不允许出现逗号,请修正后上传")
                    return false
                }

                if (this.accept && this.accept != '*') {
                    let nowFileType = '.' + file.name.suffix(this.accept);
                    let acceptGroup = (this.accept).split(',');

                    if (!acceptGroup.find(item => item === nowFileType)) {
                        toast("请选择正确的文件类型进行上传");
                        return false
                    }
                }

                var tempNdaname = file.name.substring(0, file.name.indexOf('.'))
                console.log('????????????????????????', tempNdaname)
                console.log(file.name, this.oldShowList);
                if (this.oldShowList.length != 0) {
                    for (let i = 0; i < this.oldShowList.length; i++) {
                        if (this.oldShowList[i].name == tempNdaname) {
                            // this.$Notice.warning({
                            //     title: '文件重复上传',
                            //     desc: '请重新上传此文件，文件已上传'
                            // });
                            toast("文件重复上传")
                            return false
                        }
                    }
                }
                let fileReader = new FileReader(),
                    blobSlice = File.prototype.mozSlice || File.prototype.webkitSlice || File.prototype.slice,
                    chunkSize = 2097152,
                    chunks = Math.ceil(file.size / chunkSize),
                    currentChunk = 0,
                    spark = new SparkMD5.ArrayBuffer();
                const loadNext = () => {
                    var start = currentChunk * chunkSize,
                        end = start + chunkSize >= file.size ? file.size : start + chunkSize;
                    fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
                };
                loadNext();
                fileReader.onload = (e) => {
                    spark.append(e.target.result);
                    currentChunk++;
                    if (currentChunk < chunks) {
                        loadNext();
                    } else {
                        this.md5Hash = spark.end();
                        var mdfives = this.md5Hash
                        if (this.md5Hash != '') {
                            var partSize = 2097152;
                            var fileSize = file.size;
                            console.log('+++++++++++++++++++++++++', _this.accessKeyId, _this.accessKeySecret, _this.stsToken)
                            var obsClient = _this.getObsClient();
                            obsClient.initiateMultipartUpload({
                                Bucket: "anne-bqj-file1",
                                Key: "file/" + mdfives + "." + file.name.substring(file.name.lastIndexOf(".") + 1)
                                // Key:"file/" + file.name
                            }).then(function (result) {
                                console.log('最终获取到华为云obs的结果', result)
                                var uploadId = result.InterfaceResult.UploadId;
                                console.log('uploadId:' + uploadId);
                                var partCount = fileSize % partSize === 0 ? Math.floor(fileSize / partSize) : Math.floor(fileSize / partSize) + 1;
                                console.log('partCount:' + partCount);


                                var uploadPartStatus = {
                                    bucketName: "anne-bqj-file1",
                                    objectKey: result.InterfaceResult.Key,
                                    uploadId: uploadId,
                                    file: file,
                                    fileSize: fileSize,
                                    partSize: partSize,
                                    partCount: partCount,
                                    currentPartIndex: 0,
                                    parts: []
                                };

                                // _this.uploadList = [{
                                //     uid: file.uid,
                                //     name: file.name,
                                //     status: 'uploading',
                                //     type: file.type,
                                //     md5Hash:mdfives,
                                //     size:file.size
                                // }];


                                if (_this.uploadList.length != 0) {
                                    for (let i = 0; i < _this.uploadList.length; i++) {
                                        if (_this.uploadList[i].name == file.name) {
                                            console.log('进入upload', _this.uploadList)
                                            // this.$Notice.warning({
                                            //     title: '文件重复上传',
                                            //     desc: '请重新上传此文件，文件已上传'
                                            // });
                                            toast("文件重复上传")
                                            return false
                                        } else {
                                            var filetype = _this.uploadList[i].name.suffix()

                                            if (_this.fileMultiue) {
                                                switch (true) {
                                                    case reImg.test(filetype):
                                                        temppicture = temppicture + (_this.uploadList[i].size && _this.uploadList[i].size!='' ? _this.uploadList[i].size : 0)
                                                        break;
                                                    case reMusic.test(filetype):
                                                        tempmv = tempmv + (_this.uploadList[i].size && _this.uploadList[i].size!='' ? _this.uploadList[i].size : 0)
                                                        break;
                                                    case reText.test(filetype):
                                                        tempdocument = tempdocument + (_this.uploadList[i].size && _this.uploadList[i].size!='' ? _this.uploadList[i].size : 0)
                                                        break;
                                                    case reVideo.test(filetype):
                                                        tempmv = tempmv + (_this.uploadList[i].size && _this.uploadList[i].size!='' ? _this.uploadList[i].size : 0)
                                                        break;
                                                    default:
                                                        tempother = tempother + (_this.uploadList[i].size && _this.uploadList[i].size!='' ? _this.uploadList[i].size : 0)
                                                        break;
                                                }
                                            }


                                        }
                                    }
                                    var filetype = file.name.suffix()
                                    console.log('111111111111111111111111111111111111', filetype)
                                    switch (true) {
                                        case reImg.test(filetype):
                                            if (temppicture + file.size > _this.pictureType) {
                                                _this.$Notice.warning({
                                                    title: '图片上传超出最大允许上限',
                                                    // desc: '图片类文件总共不超过100M'
                                                    desc: `此处图片类文件总共不超过${_this.pictureType / 1024 / 1024}M`
                                                });
                                                return false;
                                            } else {
                                                // this.uploadList.push(file)
                                            }
                                            break;
                                        case reMusic.test(filetype):
                                            if (tempmv + file.size > _this.videoAndMusic) {
                                                _this.$Notice.warning({
                                                    title: '音视频上传超出最大允许上限',
                                                    // desc: '音视频类文件总共不超过500M'
                                                    desc: `音视频类文件总共不超过${_this.videoAndMusic / 1024 / 1024}M`

                                                });
                                                return false;
                                            } else {
                                                // this.uploadList.push(file)
                                            }
                                            break;
                                        case reText.test(filetype):
                                            if (tempdocument + file.size > _this.documnetType) {
                                                _this.$Notice.warning({
                                                    title: '文档上传超出最大允许上限',
                                                    desc: `文档类文件总共不超过${_this.documnetType / 1024 / 1024}M`
                                                });
                                                return false;
                                            } else {
                                                // this.uploadList.push(file)
                                            }
                                            break;
                                        case reVideo.test(filetype):
                                            if (tempmv + file.size > _this.videoAndMusic) {
                                                _this.$Notice.warning({
                                                    title: '音视频上传超出最大允许上限',
                                                    // desc: '音视频类文件总共不超过500M'
                                                    desc: `音视频类文件总共不超过${_this.videoAndMusic / 1024 / 1024}M`
                                                });
                                                return false;
                                            } else {
                                                // this.uploadList.push(file)
                                            }
                                            break;
                                        default:
                                            if (tempother + file.size > _this.otherType) {
                                                _this.$Notice.warning({
                                                    title: '文件上传超出最大允许上限',
                                                    desc: `除文档，图片，音视频类其他文件总共不超过${_this.otherType / 1024 / 1024}M`
                                                });
                                                return false;
                                            } else {
                                                // this.uploadList.push(file)
                                            }
                                            break;
                                    }
                                } else {
                                    var filetype = file.name.suffix()
                                    console.log('2222222222222222222222222222222222222222222', filetype)
                                    switch (true) {
                                        case reImg.test(filetype):
                                            // temppicture = temppicture + file.size
                                            if (file.size > _this.pictureType) {
                                                _this.$Notice.warning({
                                                    title: '图片上传超出最大允许上限',
                                                    desc: `此处图片类文件总共不超过${_this.pictureType / 1024 / 1024}M`
                                                    // desc: '图片类文件总共不超过100M'
                                                });
                                                return false;
                                            } else {
                                                // this.uploadList.push(file)
                                            }
                                            break;
                                        case reMusic.test(filetype):
                                            // tempmv = tempmv + file.size
                                            if (file.size > _this.videoAndMusic) {
                                                _this.$Notice.warning({
                                                    title: '音视频上传超出最大允许上限',
                                                    // desc: '音视频类文件总共不超过500M'
                                                    desc: `音视频类文件总共不超过${_this.videoAndMusic / 1024 / 1024}M`

                                                });
                                                return false;
                                            } else {
                                                // this.uploadList.push(file)
                                            }
                                            break;
                                        case reText.test(filetype):
                                            // tempdocument = tempdocument+file.size
                                            // if(tempdocument+file.size > documnetType){
                                            if (file.size > _this.documnetType) {
                                                _this.$Notice.warning({
                                                    title: '文档上传超出最大允许上限',
                                                    // desc: '文档类文件总共不超过20M'
                                                    desc: `文档类文件总共不超过${_this.documnetType / 1024 / 1024}M`
                                                });
                                                return false;
                                            } else {
                                                // this.uploadList.push(file)
                                            }
                                            break;
                                        case reVideo.test(filetype):
                                            // tempmv = tempmv + file.size
                                            if (file.size > _this.videoAndMusic) {
                                                _this.$Notice.warning({
                                                    title: '音视频上传超出最大允许上限',
                                                    // desc: '音视频类文件总共不超过500M'
                                                    desc: `音视频类文件总共不超过${_this.videoAndMusic / 1024 / 1024}M`
                                                });
                                                return false;
                                            } else {
                                                // this.uploadList.push(file)
                                            }
                                            break;
                                        default:
                                            // tempother = tempother + file.size
                                            if (file.size > _this.otherType) {
                                                _this.$Notice.warning({
                                                    title: '文件上传超出最大允许上限',
                                                    // desc: '除文档，图片，音视频类其他文件总共不超过200M'
                                                    desc: `除文档，图片，音视频类其他文件总共不超过${_this.otherType / 1024 / 1024}M`
                                                });
                                                return false;
                                            } else {
                                                // this.uploadList.push(file)
                                            }
                                            break;
                                    }
                                }

                                if (_this.fileMultiue) {
                                    console.log('判断最大次数-0-0-0-0-0-0-0-0-0-0-0-0-0-', _this.oldShowList.length + 1, _this.maxNumber)
                                    if (_this.oldShowList.length + 1 > _this.maxNumber) {
                                        // toast('存证文件不能超过10个文件')
                                        toast(`文件不能超过${_this.maxNumber}个`);
                                        return false;
                                    }
                                    let allSize = 0;
                                    _this.oldShowList.forEach(item => {
                                        allSize += item.size;
                                    })

                                    allSize = allSize + file.size;

                                    if (allSize > _this.maxSize * 1024) {
                                        toast(`所有文件不能超过${_this.maxSize / 1024}M`)
                                        return false
                                    } else {
                                        _this.uploadList = _this.oldShowList.concat([{
                                            uid: file.uid,
                                            name: file.name,
                                            status: 'uploading',
                                            uploadProgress: 0,
                                            type: file.type,
                                            md5Hash: mdfives,
                                            size: file.size
                                        }])
                                    }


                                } else {
                                    _this.uploadList = [{
                                        uid: file.uid,
                                        name: file.name,
                                        status: 'uploading',
                                        uploadProgress: 0,
                                        type: file.type,
                                        md5Hash: mdfives,
                                        size: file.size
                                    }]
                                }

                                _this.$emit("listentochildevent", _this.uploadList)


                                _doUpload(obsClient, uploadPartStatus, _this).then((doneResult, _parts) => {
                                    globalContext.currentTaskNum = 0;
                                    console.log(`done signal is: ${doneResult}, ${_parts}`);
                                    let layout = uploadPartStatus.objectKey.substring(uploadPartStatus.objectKey.lastIndexOf(".") + 1);
                                    // if(_this.fileMultiue){
                                    //     if(_this.oldShowList.length+1>_this.maxNumber){
                                    //         // toast('存证文件不能超过10个文件')
                                    //         toast(`文件不能超过${_this.maxNumber}个`);
                                    //         return false;
                                    //     }
                                    //     let allSize = 0 ;
                                    //     _this.oldShowList.forEach(item=>{
                                    //         allSize += item.size ;
                                    //     })
                                    //
                                    //     if(allSize >_this.maxSize*1024)
                                    //     {
                                    //         toast(`所有文件不能超过${_this.maxSize/1024}M`)
                                    //         return false
                                    //     }
                                    //     _this.uploadList = _this.oldShowList.concat([{
                                    //         uid: file.uid,
                                    //         name: file.name,
                                    //         status: 'done',
                                    //         type: file.type,
                                    //         md5Hash:mdfives,
                                    //         url:'http://file.bqj.cn/'+result.InterfaceResult.Key,
                                    //         result:HWC_KEY + result.InterfaceResult.Key,
                                    //         attachmentUrl:'http://file.bqj.cn/'+result.InterfaceResult.Key,
                                    //         size:file.size
                                    //     }])
                                    //     // _this.oldShowList = Array.from(new Set(_this.uploadList))
                                    //     // if(_this.oldShowList.length>0){
                                    //     //     _this.uploadList = _this.oldShowList.push(_this.uploadList)
                                    //     // }
                                    // }else{
                                    //      _this.uploadList = [{
                                    //         uid: file.uid,
                                    //         name: file.name,
                                    //         status: 'done',
                                    //         type: file.type,
                                    //         md5Hash:mdfives,
                                    //         url:'http://file.bqj.cn/'+result.InterfaceResult.Key,
                                    //         result:HWC_KEY + result.InterfaceResult.Key,
                                    //         attachmentUrl:'http://file.bqj.cn/'+result.InterfaceResult.Key,
                                    //         size:file.size
                                    //     }]
                                    // }

                                    let resultUploadList = _this.uploadList;
                                    for (let j = 0; j < resultUploadList.length; j++) {
                                        if (file.uid == resultUploadList[j].uid) {
                                            resultUploadList[j] = {
                                                uid: file.uid,
                                                name: file.name,
                                                status: 'done',
                                                type: file.type,
                                                md5Hash: mdfives,
                                                url: 'https://file.bqj.cn/' + result.InterfaceResult.Key,
                                                result: HWC_KEY + result.InterfaceResult.Key,
                                                attachmentUrl: 'https://file.bqj.cn/' + result.InterfaceResult.Key,
                                                size: file.size
                                            }

                                        }


                                    }

                                    _this.uploadList = resultUploadList;


                                    console.log('++++++++++++++++++++++++++++++++++', _this.uploadList)
                                    _this.$emit("listentochildevent", _this.uploadList)
                                    return false;
                                }).catch(e => {
                                    console.error(e);
                                    _this.uploadErrorRemove(file);

                                    return false;
                                });
                            }).catch(e => {
                                console.error(e);
                                _this.uploadErrorRemove(file);
                                return false;
                            });
                        }
                    }
                }
                // this.getObsClient()
            },
            _getHuaWeiToken: async function () {
                await getHuaWeiToken().then((res) => {
                    console.log('获取的华为云的临时cookie', res)
                    if (res.code == 200) {
                        this.accessKeyId = res.result.accessKeyId;
                        this.accessKeySecret = res.result.accessKeySecret;
                        this.stsToken = res.result.securityToken;
                    }
                })
            },
            getObsClient() {
                let _this = this
                var obsClient = new window.ObsClient({
                    access_key_id: _this.accessKeyId,
                    secret_access_key: _this.accessKeySecret,
                    security_token: _this.stsToken,
                    server: "obs.cn-north-4.myhuaweicloud.com",
                    timeout: 60 * 5,
                })
                return obsClient;
            },
            //清空loadlist数组
            clearUploadList() {
                this.uploadList = [];
            },

            //上传失败，清除数据
            uploadErrorRemove(file) {
                let _this = this;
                let errorUploadList = _this.uploadList;
                for (let k = 0; k < errorUploadList.length; k++) {
                    if (file.uid == errorUploadList[k].uid) {
                        errorUploadList.splice(k, 1)
                        globalContext.currentTaskNum = 0;
                        toast('上传失败');
                    }
                }
                _this.uploadList = errorUploadList;
                _this.$emit("listentochildevent", _this.uploadList)
            }
        },

    }
</script>
<style scoped lang="less">
    .myu_upload {
        justify-content: center;
        display: flex;
        flex-direction: column;
        align-items: center;

        p {
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 20px;
            margin-top: 10px;
        }
    }

    .btn_upload {
        width: 138px;
        height: 38px;

        p {
            line-height: 38px;
        }

    }

    .bgHover {
        width: 138px;
        height: 38px;

        p {
            line-height: 38px;
        }

        &:hover {
            background: #FFD800;
            border: 1px solid #FFD800;
        }
    }

    .myupleft {
        margin-top: 20px;
        text-align: center;

        /deep/ .ivu-upload {
            width: 175px;
        }
    }
</style>